import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A holiday CompSci reading list for you 🎅",
  "description": "",
  "published": "2019-12-20T00:00:00.000Z",
  "redirect_from": ["/blog/a-holiday-compsci-reading-list-for-you-%f0%9f%8e%85/swizec/9265"],
  "categories": "Learning, Personal",
  "hero": "./img/techletter.app-screenshot-1576863911117.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A friend told me that he doesn't read blogs anymore. No more hasty notes by half experts. No more podcasts, no more newsletters, no more thoughtfluencers. He's done with all that crap.`}</p>
    <p>{`Instead, he reads textbooks and books from experts with decades of experience in a field. Books written at the end of a long and fruitful research career.`}</p>
    <p>{`And you know what? I'm kind of the same.`}</p>
    <p>{`As you grow in expertise, finding valuable material to learn from becomes harder and harder. Advice begins to repeat itself. Every blog or article feels like `}<em parentName="p">{`"Yeah yeah heard that before, and that, yep that too"`}</em></p>
    <p>{`It becomes boring.`}</p>
    <p>{`Not because the field is boring, not because you aren't passionate, but because you've outgrown the common advice. You need something more.`}</p>
    <p>{`Here's a fun thought:`}</p>
    <blockquote>
      <p parentName="blockquote">{`If the number of developers doubles every 5 years, then with 5 years of experience `}<strong parentName="p">{`you're more experienced than half the industry`}</strong></p>
    </blockquote>
    <p>{`🤯`}</p>
    <p><a parentName="p" {...{
        "href": "https://blog.cleancoder.com/uncle-bob/2014/06/20/MyLawn.html"
      }}>{`Quoted from Bob Martin`}</a>{`, famous for writing Clean Code and others.`}</p>
    <p>{`Maybe that's why developers love to jump in a new stack or invent a whole new technology every 5 years or so. We get bored and want something new to learn voraciously.`}</p>
    <p>{`So to be honest, while I `}<em parentName="p">{`write`}</em>{` articles, I rarely read them anymore. I prefer to do my own research and follow the raw expert stream of thoughts on twitter. It's like a bazaar of ideas and I love that. Sometimes I read books.`}</p>
    <p>{`But I don't follow coding podcasts, I don't read coding blogs, I skim documentation, and I read every 3rd paragraph of google search results.`}</p>
    <p>{`My favorite media these days are long-form audiobooks.`}</p>
    <p>{`Sometimes this leads to embarrassing moments on twitter where half the Vue community tells me I'm wrong.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1207113674604736512"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "137.21973094170403%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'549\\'%20viewBox=\\'0%200%20400%20549\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2021c-5%203-7%208-7%2013l2%206c1%201%202%202%201%203%200%201%205%204%209%205s10%200%2012-3c2-2%202-2%200-2l-4-1c0-3%202-6%205-6h2l2-2c2-2-1-9-4-10l-3-3c0-3-10-3-15%200m4%209c0%204-2%206-5%206s-3%200-1%204c3%209%209%209%2013%200%202-4%202-4%200-4-3%200-5-2-5-6l-1-3-1%203m27%2037v6h4c4-1%206-3%206-6%200-4-3-7-7-7h-3v7m25%20103l-1%20146v145h265V170l-132-1-132%201m96%20329c-5%205-2%2014%205%2013%207-2%209-7%204-12-3-3-6-4-9-1m94-1c-9%201-7%2014%202%2014%202%200%202%200%201-1s-1-1%201-1%205-3%205-5c0-3-1-5-3-5l-2-1c1-1-1-2-4-1m53%200c-4%202-6%2010-2%2012%208%206%2017-5%209-11-3-2-3-2-7-1m-20%202c-3%203-3%204-1%208s6%204%206-1c0-2%201-3%202-2v2c-2%202-1%203%201%203%203%200%205-5%202-7l-2-3c0-3-6-3-8%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/87c35598426d13a4748c2695721ee1dc/ca0a1/techletter.app-screenshot-1576863911117.webp 223w", "/static/87c35598426d13a4748c2695721ee1dc/75680/techletter.app-screenshot-1576863911117.webp 445w", "/static/87c35598426d13a4748c2695721ee1dc/0ba47/techletter.app-screenshot-1576863911117.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/87c35598426d13a4748c2695721ee1dc/e92b6/techletter.app-screenshot-1576863911117.png 223w", "/static/87c35598426d13a4748c2695721ee1dc/e66bf/techletter.app-screenshot-1576863911117.png 445w", "/static/87c35598426d13a4748c2695721ee1dc/6af66/techletter.app-screenshot-1576863911117.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/87c35598426d13a4748c2695721ee1dc/6af66/techletter.app-screenshot-1576863911117.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`All part of learning. ❤️`}</p>
    <h2 {...{
      "id": "so-if-youre-ready-for-a-challenge-"
    }}>{`So if you're ready for a challenge ...`}</h2>
    <p>{`... here's what I recommend: A holiday reading list.`}</p>
    <p>{`Computer science papers. The good stuff. The stuff that's stood the test of time. The papers and lectures that people have been quoting for years and decades.`}</p>
    <p>{`Some of this is `}<a parentName="p" {...{
        "href": "https://twitter.com/Swizec/status/1207496122303832065"
      }}>{`crowd sourced`}</a>{` so I haven't read all of them yet. Enjoy :)`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://www.cs.virginia.edu/~robins/Turing_Paper_1936.pdf"
        }}>{`Turing's On Computable Numbers`}</a>{`, the birth of the computer era`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "http://people.math.harvard.edu/~ctm/home/text/others/shannon/entropy/entropy.pdf"
        }}>{`Shannon's A Mathematical Theory of Communication`}</a>{`, a paper so good I used it as a textbook in college. Everything we do on the web depends on these ideas`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://www.cs.virginia.edu/~robins/YouAndYourResearch.html"
        }}>{`Hamming's You and Your Research`}</a>{`, a collection of life lessons from Richard Hamming that you should read every few years`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://www.youtube.com/watch?v=ji5_MqicxSo"
        }}>{`Randy Pauschs's Final Lecture`}</a>{`, an inspiring tale from the end of a wonderful career in computer research. You should watch it every few years`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://www.youtube.com/watch?v=NM-zWTU7X-k"
        }}>{`Feynman: Knowing vs Understanding`}</a>{`, an important 5 minute lecture that strikes at the core of this post. Read Surely You're Joking Richard Feynman for wonderful insights into thinking itself`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://www.scottaaronson.com/papers/philos.pdf"
        }}>{`Why Philosophers Should Care About Computational Complexity`}</a>{`, a paper I plan to read over the holidays. It explores the importance of computability and complexity in life. A version of this I enjoyed as an audiobook was `}<a parentName="li" {...{
          "href": "https://brianchristian.org/algorithms-to-live-by/"
        }}>{`Algorithms to Live By`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://www.inf.ed.ac.uk/teaching/courses/seoc/2005_2006/resources/statecharts.pdf"
        }}>{`Statecharts: A visual formalism for complex systems`}</a>{`, another paper I plan to read. It talks about state machines and how to use them. And most of what we do as a web developers are state machines`}</li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "https://arxiv.org/vc/arxiv/papers/1008/1008.1459v8.pdf"
        }}>{`Actor Model of Computation`}</a>{`, a paper about a different model of programming. We don't use this on the web very often, but it's popular in the gaming industry. I'm excited to learn from it.`}</li>
    </ol>
    <p>{`That's plenty for a week, have fun. I know I will :)`}</p>
    <p>{`See you next year. Happy holidays and don't forget to call your grandma.`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      